// styles/adminStyles.ts
import { makeStyles } from "@mui/styles";
import { THEME_COLORS } from "../../context/constants";

export const useAdminStyles = makeStyles({
  adminLayout: {
    display: "flex",
    minHeight: "100vh",
    backgroundColor: "#f5f5f5",
  },
  adminSidebar: {
    width: 250,
    backgroundColor: THEME_COLORS.darkYellow,
    color: "white",
    padding: "1rem",
  },
  adminContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    overflow: "hidden",
  },
  adminHeader: {
    backgroundColor: THEME_COLORS.darkYellow,
    color: "white",
    padding: "1rem",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  adminMain: {
    padding: "2rem",
    flex: 1,
    overflowX: "auto",
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
    gap: "1rem",
    marginTop: "1rem",
  },
  card: {
    backgroundColor: "white",
    borderRadius: "8px",
    padding: "1.5rem",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  cardTitle: {
    color: THEME_COLORS.darkYellow,
    marginBottom: "1rem",
  },
  cardValue: {
    fontSize: "2rem",
    fontWeight: "bold",
    color: THEME_COLORS.yellow,
  },
});
